import { Images } from "@assets/images";

function ShippingDeliveryPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen flex justify-center py-8">
      <div className="px-10 py-8 bg-white shadow-md rounded-lg max-w-screen-lg mx-auto">
        <div className="flex justify-center mb-8">
          <img
            className="w-2/3 md:w-1/3"
            src={Images.LogoText.default}
            alt="Logo"
          />
        </div>
        <h1 className="text-3xl font-bold mb-4 text-gray-800 text-center">
          Chính sách bảo hành sản phẩm
        </h1>
        <p className=" text-gray-600">
          <p className="my-2">
            Dịch vụ của chúng tôi sẽ bàn giao trực tuyến qua email và tài khoản
            trên ứng dụng của khách hàng: Thông thường chúng tôi sẽ gửi thông
            tin kích hoạt dịch vụ thành công cho quý khách trong vòng 24h kể từ
            khi thanh toán thành công.
          </p>
          <p className="my-2">
            Chúng tôi không áp dụng hình thức hay dịch vụ vận chuyển của bên
            khác
          </p>
        </p>
      </div>
    </div>
  );
}

export default ShippingDeliveryPolicy;
